"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLiveAnnounce = void 0;
const react_1 = require("react");
/**
 * Announce a message on voice over whenever you do an action. This is
 * especially helpful when you have an action that adds or deletes an element
 * from the screen.
 */
function useLiveAnnounce() {
    const [announcedMessage, setAnnouncedMessage] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        let target;
        if (announcedMessage) {
            target = createAnnouncedElement();
            setTimeout(() => target.append(announcedMessage), 100);
        }
        return () => target === null || target === void 0 ? void 0 : target.remove();
    }, [announcedMessage]);
    return {
        liveAnnounce: (message) => {
            setAnnouncedMessage(message);
        },
    };
}
exports.useLiveAnnounce = useLiveAnnounce;
// eslint-disable-next-line max-statements
function createAnnouncedElement() {
    const el = document.createElement("div");
    el.style.position = "absolute";
    el.style.width = "1px";
    el.style.height = "1px";
    el.style.overflow = "hidden";
    el.style.clipPath = " inset(100%)";
    el.style.whiteSpace = " nowrap";
    el.style.top = "0";
    el.setAttribute("role", "status");
    el.setAttribute("aria-atomic", "true");
    el.setAttribute("aria-live", "assertive");
    document.body.appendChild(el);
    return el;
}
